module.exports = __webpack_public_path__ + "img/project3_6.png.a5f68a5c.webp";